import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AcessoNegadoComponent } from './components/acesso-negado/acesso-negado.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { FormularioJantarComponent } from './components/formulario-jantar/formulario-jantar.component';
import { LoginComponent } from './components/login/login.component';
import { AdesaoPlanoFamiliaComponent } from './components/adesao-plano-familia/adesao-plano-familia.component';
import { RedeCredenciadaPublicaComponent } from './components/rede-credenciada/rede-credenciada.component';
import { SimuladorPlanoFamiliaComponent } from './components/simulador-plano-familia/simulador-plano-familia.component';
import { DeclaracaoComponent } from './components/declaracao/declaracao.component';
const routes: Routes = [
  { path: 'access-denied', component: AcessoNegadoComponent, data: { title: 'Acesso Negado' } },
  { path: 'adesao-plano-familia', component: AdesaoPlanoFamiliaComponent, data: { title: 'Adesão Plano Familia' } },
  { path: 'declaracao/:shortenId', component: DeclaracaoComponent, data: { title: 'Declaração', } },
  { path: 'erro', component: ErrorPageComponent, data: { title: 'Erro' } },
  { path: 'formulario-jantar', component: FormularioJantarComponent, data: { title: 'Formulário Jantar' } },
  { path: 'guia-rede-credenciada', component: RedeCredenciadaPublicaComponent, data: { title: 'Guia Rede Credenciada' } },
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  { path: 'simulador-plano-familia', component: SimuladorPlanoFamiliaComponent, data: { title: 'Simulador Plano Família' } },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicoRoutingModule { }
